import { useRef } from "react";
import { Typography } from "antd";
import AppColumnActionOption from "../../../@richbeauty/core/AppColumnActionOption";
import IntlMessages from "../../../@richbeauty/utility/IntlMessages";
import AppCustomModalWrapper from "../../../@richbeauty/core/AppCustomModalWrapper";
import useAppConfirmModal from "../../../hooks/useAppConfirmModal";
import { revalidateCustomerLeads } from "../../../@richbeauty/utility/helper/cacheRevalidator";

import EditCustomerLeadModal from "./CreateAndEditLeadModal/EditCustomerLeadModal";
// import useDeleteCustomerLeads from "hooks/apis/customerLeads/useDeleteCustomerLeads";
import {
  DeleteOutlined,
  EditOutlined,
  PushpinOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { PERMISSIONS } from "shared/constants/AppEnums";
// import ViewCustomerLeadNotesModel from "./ViewCustomerLeadNotesModel";
// import ConvertToDealModal from "./ConvertToDealModal";
import toast from "react-hot-toast";
import ViewCustomerLeadNotesModel from "./ViewCustomerLeadNotesModel";
import ConvertToUserModal from "./ConvertToUserModal";
import useDeleteCustomerLeads from "hooks/apis/customerLeads/useDeleteCustomerLeads";

const CustomerLeadColumnActionOption = ({
  id,
  // eslint-disable-next-line no-unused-vars
  campaignId,
  status,
  leadData,
}) => {
  const isConverted = status === "CONVERTED";

  const updateCustomerLeadModalRef = useRef();
  const viewCustomerLeadNotesModalRef = useRef();
  const convertToUserModalRef = useRef();
  const { trigger: triggerDeleteCustomerLeads } = useDeleteCustomerLeads();
  const { contextHolder, openModal } = useAppConfirmModal();
  const handleDeleteCustomerLead = async () => {
    if (isConverted) return;
    openModal({
      // @ts-ignore
      title: <IntlMessages id="app.customerLeads.deleteCustomerLead" />,
      // @ts-ignore
      okText: <IntlMessages id="common.save" />,
      // @ts-ignore
      cancelText: <IntlMessages id="common.cancel" />,
      onOk: () => {
        triggerDeleteCustomerLeads([id], {
          onSuccess: async (data) => {
            revalidateCustomerLeads();
            // @ts-ignore
            toast.success(data?.message);
          },
          onError: (error) => toast.error(error?.message),
        });
      },
    });
  };

  return (
    <>
      <AppColumnActionOption
        items={[
          {
            scopes: [PERMISSIONS.EDIT_CUSTOMER_LEAD],
            isDisabled: isConverted,
            label: (
              <div style={{ color: isConverted ? "#00000040" : "black" }}>
                <EditOutlined />{" "}
                <IntlMessages id="app.customerLeads.editCustomerLead" />
              </div>
            ),
            onClick: () => {
              if (isConverted) return;
              // @ts-ignore
              updateCustomerLeadModalRef.current?.openModal();
            },
          },
          {
            label: (
              <>
                <Typography.Text>
                  <PushpinOutlined />{" "}
                  <IntlMessages id="app.customerLeads.notes" />
                </Typography.Text>
              </>
            ),
            // @ts-ignore
            onClick: () => viewCustomerLeadNotesModalRef.current?.openModal(),
          },
          {
            scopes: [PERMISSIONS.EDIT_CUSTOMER_LEAD],
            isDisabled: isConverted,
            label: (
              <Typography.Text
                style={{ color: isConverted ? "#00000040" : "black" }}
              >
                <SyncOutlined />{" "}
                <IntlMessages id="app.customerLeads.convertToUser" />
              </Typography.Text>
            ),
            onClick: () => {
              if (isConverted) return;
              // @ts-ignore
              convertToUserModalRef.current?.openModal();
            },
          },
          {
            scopes: [PERMISSIONS.DELETE_CUSTOMER_LEAD],
            isDisabled: isConverted,
            label: (
              <Typography.Text
                type="danger"
                style={{ color: isConverted ? "#00000040" : "danger" }}
              >
                <DeleteOutlined />{" "}
                <IntlMessages id="app.customerLeads.deleteCustomerLead" />
              </Typography.Text>
            ),
            onClick: handleDeleteCustomerLead,
          },
        ]}
      />
      <// @ts-ignore
      AppCustomModalWrapper
        ref={updateCustomerLeadModalRef}
      >
        <EditCustomerLeadModal
          // @ts-ignore
          id={id}
        />
      </AppCustomModalWrapper>
      <// @ts-ignore
      AppCustomModalWrapper
        ref={viewCustomerLeadNotesModalRef}
      >
        <ViewCustomerLeadNotesModel
          // @ts-ignore
          id={id}
        />
      </AppCustomModalWrapper>
      <// @ts-ignore
      AppCustomModalWrapper
        ref={convertToUserModalRef}
      >
        <ConvertToUserModal
          // @ts-ignore
          leadData={leadData}
        />
      </AppCustomModalWrapper>
      {contextHolder}
    </>
  );
};

export default CustomerLeadColumnActionOption;
